import { Heading, Container, Section, BottomSection } from "../../visitors/data-table/index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useRef, useState } from "react";
import { TFilter, TMetaData, TVisitorsDataTable } from "types/analytics.types";
import {
  downloadVisitorsAnalyticsData,
  getVisitorsAnalyticsData,
  getVisitorsAnalyticsMetaData,
} from "apis/analytics/visitors/datatable";
import VisitorsFilter from "./filters";
import VisitorsTable from "./table";

const DataTable = () => {
  const getAdjustedDate = (unit: string, n: number): Date => {
    const date = new Date();
    if (unit === "m") {
      date.setMonth(date.getMonth() + n);
    } else {
      date.setDate(date.getDate() + n);
    }
    return date;
  };

  const [metadata, setMetadata] = useState<TMetaData[]>([]);
  const [data, setData] = useState<TVisitorsDataTable[]>([]);
  const [selectedColumn, setSelectedColumn] = useState<TMetaData[]>([]);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [filter, setFilter] = useState<TFilter[]>([]);
  const loading = useRef<boolean>(false);
  const [filterDate, setFilterDate] = useState<{ start: string; end: string }>({
    start: getAdjustedDate("d", -31).toDateString(),
    end: getAdjustedDate("d", -1).toDateString(),
  });

  const setMetaData = async () => {
    const res = await getVisitorsAnalyticsMetaData();
    if (res.success) {
      setMetadata(res.data ?? []);
    }
  };

  const getMeetingData = async (page: number) => {
    const res = await getVisitorsAnalyticsData(page, filterDate, filter);
    if (res.success) {
      setData(res.data?.visitorsDashboards ?? []);
      setTotalPage(res.data?.totalPageNumber ?? 0);
      setCurrentPage(page);
    }
  };

  const openCSV = async () => {
    if (loading.current) return;
    loading.current = true;

    const res = await downloadVisitorsAnalyticsData(filterDate.start, filterDate.end);
    if (res.success) {
      window.open(res.data);
    }

    loading.current = false;
  };

  useEffect(() => {
    setMetaData();
  }, []);

  return (
    <Container>
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 20px",
          }}
        >
          방문자 관리 데이터
        </UI.Typography>
        <div className="right-side">
          <div className="annotation">
            <UI.Icon name="info" color="var(--alias-color-label-assistive)" size={20} />
            <UI.Typography type="label01" color="var(--alias-color-label-alternative)">
              CSV 다운로드는 ‘기간'만 적용된 데이터를 다운받으실 수 있습니다. (‘항목’, ‘필터’ 제외)
            </UI.Typography>
          </div>
          <UI.Button title="CSV 다운로드" primary={false} onClick={openCSV} />
        </div>
      </Heading>
      <Section>
        <VisitorsFilter
          metadata={metadata}
          onChangeColumn={setSelectedColumn}
          onChangeData={setData}
          onChangeFilter={setFilter}
          onChangeCurrentPage={setCurrentPage}
          onChangeTotalPage={setTotalPage}
          onChangeDate={(start: string, end: string) => {
            setFilterDate({ start, end });
          }}
        />
      </Section>
      <BottomSection>
        {selectedColumn.length > 0 && <VisitorsTable metadata={selectedColumn} data={data} page={currentPage} />}
        {totalPage > 0 && (
          <UI.Pagination
            pageCount={totalPage}
            currentPage={currentPage}
            onChange={(page) => {
              getMeetingData(page);
            }}
          />
        )}
      </BottomSection>
    </Container>
  );
};

export default DataTable;
